import { DropdownOption } from 'components/dropdown/component'

// Image Style Options
export const ImageStyleOptions: DropdownOption[] = [
  { key: 'realistic', value: 'realistic', description: 'Realistic Photography' },
  { key: 'digital-art', value: 'digital-art', description: 'Digital Art' },
  { key: 'illustration', value: 'illustration', description: 'Illustration' },
  { key: 'painting', value: 'painting', description: 'Painting' },
  { key: 'sketch', value: 'sketch', description: 'Sketch' },
  { key: 'cartoon', value: 'cartoon', description: 'Cartoon' },
  { key: 'minimalist', value: 'minimalist', description: 'Minimalist' },
  { key: 'abstract', value: 'abstract', description: 'Abstract' },
]

// Image Quality Options
export const ImageQualityOptions: DropdownOption[] = [
  { key: 'draft', value: 'draft', description: 'Draft Quality' },
  { key: 'standard', value: 'standard', description: 'Standard Quality' },
  { key: 'high', value: 'high', description: 'High Quality' },
  { key: 'premium', value: 'premium', description: 'Premium Quality' },
]

// Subject Focus Options
export const SubjectFocusOptions: DropdownOption[] = [
  { key: 'people', value: 'people', description: 'People & Portraits' },
  { key: 'objects', value: 'objects', description: 'Objects & Products' },
  { key: 'landscape', value: 'landscape', description: 'Landscapes & Nature' },
  { key: 'architecture', value: 'architecture', description: 'Buildings & Architecture' },
  { key: 'technology', value: 'technology', description: 'Technology & Digital' },
  { key: 'business', value: 'business', description: 'Business & Corporate' },
  { key: 'lifestyle', value: 'lifestyle', description: 'Lifestyle & Events' },
  { key: 'abstract', value: 'abstract', description: 'Abstract & Conceptual' },
]

// Color Scheme Options
export const ColorSchemeOptions: DropdownOption[] = [
  { key: 'vibrant', value: 'vibrant', description: 'Vibrant Colors' },
  { key: 'muted', value: 'muted', description: 'Muted Colors' },
  { key: 'monochrome', value: 'monochrome', description: 'Monochrome' },
  { key: 'warm', value: 'warm', description: 'Warm Tones' },
  { key: 'cool', value: 'cool', description: 'Cool Tones' },
  { key: 'pastel', value: 'pastel', description: 'Pastel Colors' },
  { key: 'bold', value: 'bold', description: 'Bold Colors' },
  { key: 'natural', value: 'natural', description: 'Natural Colors' },
]

// Mood Options
export const MoodOptions: DropdownOption[] = [
  { key: 'professional', value: 'professional', description: 'Professional' },
  { key: 'friendly', value: 'friendly', description: 'Friendly' },
  { key: 'energetic', value: 'energetic', description: 'Energetic' },
  { key: 'calm', value: 'calm', description: 'Calm' },
  { key: 'dramatic', value: 'dramatic', description: 'Dramatic' },
  { key: 'playful', value: 'playful', description: 'Playful' },
  { key: 'serious', value: 'serious', description: 'Serious' },
  { key: 'inspiring', value: 'inspiring', description: 'Inspiring' },
]

// Complexity Options
export const ComplexityOptions: DropdownOption[] = [
  { key: 'simple', value: 'simple', description: 'Simple & Clean' },
  { key: 'moderate', value: 'moderate', description: 'Moderate Detail' },
  { key: 'detailed', value: 'detailed', description: 'Highly Detailed' },
  { key: 'intricate', value: 'intricate', description: 'Intricate & Complex' },
]

// Art Style Options
export const ArtStyleOptions: DropdownOption[] = [
  { key: 'modern', value: 'modern', description: 'Modern' },
  { key: 'classic', value: 'classic', description: 'Classic' },
  { key: 'vintage', value: 'vintage', description: 'Vintage' },
  { key: 'futuristic', value: 'futuristic', description: 'Futuristic' },
  { key: 'artistic', value: 'artistic', description: 'Artistic' },
  { key: 'commercial', value: 'commercial', description: 'Commercial' },
  { key: 'editorial', value: 'editorial', description: 'Editorial' },
  { key: 'conceptual', value: 'conceptual', description: 'Conceptual' },
]

// Lighting Options
export const LightingOptions: DropdownOption[] = [
  { key: 'natural', value: 'natural', description: 'Natural Light' },
  { key: 'studio', value: 'studio', description: 'Studio Lighting' },
  { key: 'dramatic', value: 'dramatic', description: 'Dramatic Lighting' },
  { key: 'soft', value: 'soft', description: 'Soft Lighting' },
  { key: 'bright', value: 'bright', description: 'Bright & Airy' },
  { key: 'moody', value: 'moody', description: 'Moody Lighting' },
  { key: 'golden-hour', value: 'golden-hour', description: 'Golden Hour' },
  { key: 'backlighting', value: 'backlighting', description: 'Backlighting' },
]

// Default Image Preferences
export const DefaultImagePreferences = {
  style: 'realistic',
  quality: 'standard',
  subjectFocus: 'business',
  colorScheme: 'natural',
  mood: 'professional',
  complexity: 'moderate',
  artStyle: 'modern',
  lighting: 'natural',
}